import TagManager from 'react-gtm-module'
import { GA_EVENTS } from '../utils/constant'
// import localStorage from 'local-storage'

const getUserInfo = () => {
  const params = {}
  try {
    const user = JSON.parse(localStorage.getItem('authenticated'))
    params.userId = user.id
    params.userName = user.user_name
  } catch (ex) {

  }
  return params
}

export const emitGA = (event, params = { action: '', label: '' }) => {
  let data = {
    // ACCOUNT
    ACCOUNT: ({ type, action }) => ({
      category: 'Account',
      action: action,
      label: type
    }),
    // HOMEPAGE
    START_PLAYING_VIDEO: {
      category: 'Homepage',
      action: 'VideoPlay',
      label: 'Start'
    },
    STOP_PLAYING_VIDEO: {
      category: 'Homepage',
      action: 'VideoPlay',
      label: 'End'
    },
    HOMEPAGE_SIGNUP: ({ section }) => ({
      category: 'Homepage',
      action: 'SignUp',
      label: section
    }),
    HOMEPAGE_CHAT: ({ section }) => ({
      category: 'Homepage',
      action: 'ChatWithUs',
      label: section
    }),
    HOMEPAGE_INVESTMENT_OPTION: ({ type }) => ({
      category: 'Homepage',
      action: 'ViewInvestmentOption',
      label: type
    }),
    // CONTACT
    CLICK_CHAT_ICON: ({ which, action }) => ({
      category: 'Contact',
      action: action || 'ChatIcon',
      label: which || 'Manual'
    }),
    // INVESTMENT OPTIONS
    CLICK_INVESTMENT_OPTIONS_TAB: ({ label, action }) => ({
      category: 'InvestmentOptions',
      action: 'SwitchTab',
      label
    }),
    CLICK_INVESTMENT_NOW: ({ label, action }) => ({
      category: 'InvestmentOptions',
      action: 'InvestNow',
      label
    }),
    CLICK_VIEW_PROPERTIES: ({ label, action }) => ({
      category: 'InvestmentOptions',
      action: 'ViewMoreProps',
      label
    }),
    [GA_EVENTS.SECONDARY]: ({ label, action }) => ({
      category: event,
      action,
      label
    }),
    'Homepage': ({ label, action }) => ({
      category: event,
      action,
      label
    })
  }[event]

  data = typeof data === 'function' ? data(params) : data

  data && TagManager.dataLayer({
    dataLayer: { event: 'RS_EVENT', ...data, ...getUserInfo() }
  })
}

export const sendPageView = () => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'PAGE_VIEW',
      ...getUserInfo()
    }
  })
}
